module.exports = __webpack_public_path__ + "static/media/BG.9a7c4bc5.png";